import { connect } from 'react-redux';
import { IRootState } from 'redux/root_reducer';

import Cart, { StateProps } from 'components/pages/accessories/Cart';

const mapStateToProps = ({ shopify, display }: IRootState): StateProps => {
    return {
        addedItemText: shopify.message,
        headerShowing: display.headerShowing,
        isMobile: display.isMobile,
        productsCount: shopify.cartItems.length
    };
};

export default connect(mapStateToProps)(Cart);



// WEBPACK FOOTER //
// ./src/containers/pages/accessories/Cart.tsx